import CodeFilter from './CodeFilter'
import budgetCodesQuery from 'bvdash/projects/queries/budgetCodesQuery'
import scheduleCodesQuery from 'bvdash/projects/queries/scheduleCodesQuery'

const BudgetCodeFilter = budgetCodesQuery(CodeFilter)
const ScheduleCodeFilter = scheduleCodesQuery(CodeFilter)

export { BudgetCodeFilter, ScheduleCodeFilter }
